import { render, staticRenderFns } from "./UserTransactionHistory.vue?vue&type=template&id=bb1aeeea&lang=html"
import script from "./UserTransactionHistory.vue?vue&type=script&lang=js"
export * from "./UserTransactionHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports